/*--------------------------------------------------------------------------
*  Schedule Tour - Javascript validation
* -------------------------------------------------------------------------*/
import dayjs = require("dayjs");
import { initSignature } from "./jsSignature";

function displayAlertMessage(message: string) {
    return `
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
            ${message} 
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
    `
}

function validateEmail(email: any) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export default function handleScheduleTourForm() {
    const tourForm = document.querySelector('#schedule_tour_agreement') as HTMLElement;
    if (tourForm) {
        const tourFormWrapper = tourForm.querySelector('.create-listing-contract-wrapper') as HTMLElement;
        tourFormWrapper.classList.remove('hide');
    }

    // Date
    let dateStart = new Date;
    let dateEnd = new Date(dateStart.getTime() + (14 * 24 * 60 * 60 * 1000));
    let todayDate = `${dateStart.getFullYear()} - ${dateStart.getMonth() + 1} - ${dateStart.getDate()}`;

    // Property title & ID
    const propertyTitle = document.querySelector('.property_title') as HTMLElement;

    // Button element
    const scheduleTourSubmit = document.querySelector('#scheduleTourSubmit') as HTMLElement;

    // Form's input field
    // Field on form's page 1
    const scheduleTourDate = document.querySelector('#schedule_tour_p1 input[name="schedule_date"]') as HTMLInputElement;
    const scheduleTourTime = document.querySelector('#schedule_tour_p1 select[name="schedule_time"]') as HTMLInputElement;
    const scheduleTourAgreeCheckBox = document.querySelector('#schedule_tour_p1 input[name="privacy_policy"]') as HTMLInputElement;

    // Alert message section
    const alertMessage = document.querySelector('#scheduleTourForm .form_messages') as HTMLElement;

    // Click upload button to trigger the upload field
	const user_id_copy_button = document.querySelector('#tour_user_id_copy_button') as HTMLElement;
	const user_id_copy_label = document.querySelector('label[for="tour_user_id_copy"]') as HTMLElement;
    const user_id_copy_virtual_input_field = document.querySelector('.virtual-input-field') as HTMLElement;
    const user_id_copy_input_field = document.querySelector('#tour_user_id_copy') as HTMLInputElement;
	if (document.querySelector('#property-schedule-tour-wrap')) {	
		user_id_copy_button.addEventListener('click', e => {
			e.preventDefault();
			user_id_copy_label.click();
		});
        user_id_copy_virtual_input_field.addEventListener('click', e => {
			e.preventDefault();
			user_id_copy_label.click();
		});
        user_id_copy_input_field.addEventListener('change', e => {
            let filePath = user_id_copy_input_field.value;
            let fileName = filePath.replace(/^.*[\\\/]/, '');
            if(fileName) {
                user_id_copy_virtual_input_field.innerText = fileName;
            } else {
                user_id_copy_virtual_input_field.innerText = "請上載香港身份證副本";
            }
        })
    }

    // Set the visit date not before today
    if (document.querySelector('#property-schedule-tour-wrap')) {
        jQuery(scheduleTourDate).datepicker('setStartDate', dayjs().format('YYYY-MM-DD'));
    }

}

/*--------------------------------------------------------------------------
*  Schedule Tour - Ajax request when user schedule a tour
* -------------------------------------------------------------------------*/
export function handleScheduleTourSubmit() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    jQuery('.schedule_contact_form').on('click', function (e) {
        e.preventDefault();

        // Javascript validation before ajax request.
        const scheduleTourDate = document.querySelector('#schedule_tour_p1 input[name="schedule_date"]') as HTMLInputElement;
        const alertMessage = document.querySelector('#scheduleTourForm .form_messages') as HTMLElement;
        const user_id_copy_input_field = document.querySelector('#tour_user_id_copy') as HTMLInputElement;
        const scheduleTourAgreeCheckBox = document.querySelector('#schedule_tour_p1 input[name="privacy_policy"]') as HTMLInputElement;
        if (!scheduleTourDate.value) {
            alertMessage.innerHTML = displayAlertMessage('請選擇日期');
            return;
        }
        else if (!user_id_copy_input_field.value) {
            alertMessage.innerHTML = displayAlertMessage('請上載香港身份證副本');
            return;
        }
        else if (!(user_id_copy_input_field.files[0].type == 'image/jpeg' || user_id_copy_input_field.files[0].type == 'image/png')) {
            alertMessage.innerHTML = displayAlertMessage('香港身份證副本需為少於5mb的jpg');
            return;
        }
        else if (user_id_copy_input_field.files[0].size > (5 * 1048576) ) {
            alertMessage.innerHTML = displayAlertMessage('香港身份證副本需為少於5mb的jpg');
            return;
        }
        else if (!scheduleTourAgreeCheckBox.checked) {
            alertMessage.innerHTML = displayAlertMessage('需確認本人已閱讀及同意豐源地產私隱政策');
            return;
        } else {
            alertMessage.innerHTML = "";
        }

        var $this = jQuery(this);
        var $form = $this.parents('form');
        const form = $form[0];
        let data = new FormData(form);
        var $result = $form.find('.form_messages');
    
        jQuery.ajax({
            url: ajaxurl,
            data: data,
            method: $form.attr('method'),
            dataType: "JSON",
            contentType: false,
            processData: false,
    
            beforeSend: function () {
                $this.find('.houzez-loader-js').addClass('loader-show');
            },
            success: function (response) {
                if (response.success) {
                    // Clean up the entered info in the field.
                    $form.find('input[name="name"], input[name="phone"], input[name="schedule_date"], input[name="message"], input[name="privacy_policy"]').val('');
                    const virtualInputField = form.querySelector('.virtual-input-field') as HTMLElement;
                    virtualInputField.innerText = '請上載香港身份證副本';
                    const tourUserIdCopy = form.querySelector('#tour_user_id_copy') as HTMLInputElement;
                    tourUserIdCopy.value = '';
                    $form.find('input[name="privacy_policy"]').prop('checked', false);
                    $form.find('textarea').val('');
                    $result.empty().append('<div class="alert alert-success alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                } else {
                    $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                }
            },
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                console.log(err.Message);
            },
            complete: function () {
                $this.find('.houzez-loader-js').removeClass('loader-show');
            }
        });
    });
}

/*--------------------------------------------------------------------------
*  Schedule Tour - Ajax request when landlord accept a tour
* -------------------------------------------------------------------------*/
export function handleScheduleTourAccept() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    jQuery('.tour-accept-btn').on('click', function (e) {
        e.preventDefault();

        const $this = jQuery(this);
        const $form = $this.parents('form');
        const $message = $this.parent().parent();
    
        jQuery.ajax({
            url: ajaxurl,
            data: $form.serialize(),
            method: $form.attr('method'),
            dataType: "JSON",
    
            beforeSend: function () {
                $this.find('.houzez-loader-js').addClass('loader-show');
            },
            success: function (response) {
                if (response.success) {
                    $message.text(response.msg);
                } else {
                    // $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                }
            },
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
            },
            complete: function () {
                $this.find('.houzez-loader-js').removeClass('loader-show');
            }
        });
    });
}

/*--------------------------------------------------------------------------
*  Schedule Tour - Ajax request when landlord deny a tour
* -------------------------------------------------------------------------*/
export function handleScheduleTourDeny() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    jQuery('.tour-deny-btn').on('click', function (e) {
        e.preventDefault();

        const $this = jQuery(this);
        const $form = $this.parents('form');
        const $message = $this.parent().parent();
    
        jQuery.ajax({
            url: ajaxurl,
            data: $form.serialize(),
            method: $form.attr('method'),
            dataType: "JSON",
    
            beforeSend: function () {
                $this.find('.houzez-loader-js').addClass('loader-show');
            },
            success: function (response) {
                if (response.success) {
                    $message.text(response.msg);
                } else {
                    // $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                }
            },
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
            },
            complete: function () {
                $this.find('.houzez-loader-js').removeClass('loader-show');
            }
        });
    });
}

/*--------------------------------------------------------------------------
*  Schedule Tour - Show message and id card copy on tour dashboard
* -------------------------------------------------------------------------*/
export function handleScheduleTourShowMsg() {
    const allMsgBtn = document.querySelectorAll('.msg-btn');
    if (allMsgBtn) {
        allMsgBtn.forEach(msgBtn => {
            msgBtn.classList.remove('hidden');
            const msgModal = msgBtn.nextElementSibling as HTMLElement;
            const msgContent = msgModal.children[0] as HTMLElement;
            const msgClose = msgModal.children[0].children[0] as HTMLElement;
    
            msgBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                msgModal.style.display = "flex";
            })
            msgContent.addEventListener('click', (e) => {
                e.stopPropagation();
                msgModal.style.display = "flex";
            })
            msgClose.addEventListener('click', (e) => {
                e.stopPropagation();
                msgModal.style.display = "none";
            })
            window.addEventListener('click', (e) => {
                e.stopPropagation();
                msgModal.style.display = "none";
            })
        })
    }
}